// extracted by mini-css-extract-plugin
export default {"wrap":"Sidebar_wrap__CP-zf","list-body":"Sidebar_list-body__TQJ7t","item":"Sidebar_item__TMzUY"};